<template>
  <div class="history-report-bd">
    <!-- 过滤 -->
    <div class="query-filter">
      <div class="select-date">
        <h1>{{ $t('Common.com_date') }}</h1>
        <div style="margin-bottom: 16px">
          <div class="ub ub-sp">
            <custom-date-picker
              :clearable="false"
              v-model="selectDate"
              type="daterange"
              style="width: 250px"
              value-format="YYYY-MM-DD HH:mm:ss"
              :init-value="initDate"
              :picker-options="beforeToday"
              @change="getChangeData"
            ></custom-date-picker>
            <div>
              <!-- <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i> -->
              <el-button type="info" @click="onExport(1)" style="margin-left: 10px;" v-if="funcView.cleanscore_histories_location_export&&(isCoJv && !formSearch.siteId) || (!isCoJv && !formSearch.siteId)">
                <i class="icon icon-export-excel"></i>
                <span style="padding-left: 4px">{{ $t('historyScore.dao_chu_xiang_mu') }}</span>
              </el-button>
              <el-button type="info" @click="onExport(0)" v-if="funcView.cleanscore_histories_site_export">
                <i class="icon icon-export-excel"></i>
                <span style="padding-left: 4px">{{ $t('historyScore.dao_chu_qu_yu') }}</span>
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="query-filter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8" v-if="isCoJv && showSubsidiary">
              <div class="item">
                <div class="label">{{ $t('historyScore.zu_lin_fang') }}</div>
                <div class="value">
                  <custom-select
                    filterable
                    url="OrganSelect"
                    :model="formSearch"
                    :params="{ childOrgType: 'CS' }"
                    v-model="formSearch.orgId"
                    :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                    :placeholder="$t('Common.com_please_select')"
                    @change="onChangeCustomer"
                  ></custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_location') }}</div>
                <div class="value">
                  <custom-select
                    filterable
                    :listener="formSearch.orgId"
                    url="MyDeviceLocationTagSelect"
                    :model="formSearch"
                    v-model="formSearch.locationId"
                    :params="{ customerId: isCoJv ? (showSubsidiary ? formSearch.orgId : '') : userInfo.rootOrgId }"
                    :props="{ label: 'locationName', value: 'locationId', map: { locationName: 'locationName' } }"
                    :placeholder="$t('Common.com_please_select')"
                    :dataFilter="dataFilter"
                    @getList="getTagsList"
                    @change="getChangeData"
                  >
                  </custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_site') }}</div>
                <div class="value">
                  <custom-select
                    :auto="false"
                    :listener="formSearch.locationId || null"
                    url="locationSiteList"
                    :model="formSearch"
                    v-model="formSearch.siteId"
                    :params="{ locationId: formSearch.locationId, isAll: false }"
                    :props="{ label: 'siteName', value: 'siteId', map: { siteName: 'siteName' } }"
                    :placeholder="$t('Common.com_please_select')"
                    @getList="getTagsList1"
                    :dataFilter="dataFilter1"
                    @change="getChangeData"
                  >
                  </custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_belong_to_department') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('Common.com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('Common.com_filter_item') }}</div>
        <div class="values">
          <el-tag
            v-if="formSearch.orgId"
            closable
            @close="
              formSearch.orgId = '';
              formSearch.orgName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.orgName }}
          </el-tag>
          <el-tag
            v-if="formSearch.locationId"
            closable
            @close="
              formSearch.locationId = '';
              formSearch.locationName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.locationName }}
          </el-tag>
          <el-tag
            v-if="formSearch.siteId"
            closable
            @close="
              formSearch.siteId = '';
              formSearch.siteName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.siteName }}
          </el-tag>
          <el-tag
            v-if="formSearch.departmentId"
            closable
            @close="
              formSearch.departmentId = '';
              formSearch.departmentName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.departmentName }}
          </el-tag>
          <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
        </div>
      </div>
    </div>
    <!-- 未选择项目 -->
    <div class="empty-location" v-if="!formSearch.locationId">
      <span>{{ $t('historyScore.qnxxzygxm') }}</span>
    </div>
    <!-- 得分概览 -->
    <div class="chart-report" v-if="formSearch.locationId && funcView.cleanscore_histories_chart">
      <h1>{{ $t('historyScore.de_fen_gai_lan') }}</h1>
      <div class="tab-wrapper">
        <el-tabs v-model="reportType">
          <el-tab-pane :label="$t('historyScore.de_fen')" name="cleanScore"></el-tab-pane>
          <el-tab-pane :label="$t('Common.com_area_cleaned')" name="totalCleanArea"></el-tab-pane>
          <el-tab-pane :label="$t('Common.com_time_cleaned')" name="totalUsageTime"></el-tab-pane>
        </el-tabs>
      </div>
      <my-line  :lineData="reportList" :lineType="reportType"></my-line>
    </div>
    <!-- 数据详情 -->
    <div class="chart-detail" :class="{ white: formSearch.siteId }" v-if="formSearch.locationId">
      <h1>{{ $t('historyScore.shu_ju_xiang_qing') }}</h1>
      <site-list v-if="formSearch.siteId" type="date" :list="tableList" @success="getChangeData"></site-list>
      <location-list v-else type="date" :permission="{ set: funcView.cleanscore_histories_setTarget }" :list="tableList" @success="getChangeData"></location-list>
      <div class="table-footer" style="margin-top: 16px">
        <custom-pagination style="padding: 20px 24px" radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import myLine from './cleanscore_line.vue';
import locationList from './location_list.vue';
import siteList from './site_list.vue';

// i18n-lang-component
export default {
  name: 'historyReport',
  components: { myLine, locationList, siteList },
  data() {
    return {
      tagId: '',
      floorId: '',
      tags: [],
      tags1: [],
      selectDate: [],
      initDate: '',
      reportList: [],
      reportType: '',
      formSearch: {
        isExportLocationReport: '',
        orgId: undefined,
        orgName: '',
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',
        startDate: '',
        endDate: '',
        startDateBeforeOffSet: '',
        endDateBeforeOffSet: '',
        pageNum: 1,
        pageSize: 50,
        showSubsidiary: '',
        departmentId: '',
        departmentName: ''
      },
      totalRows: 0,
      tableList: [],

      dialogVisible: false,
      dialogModel: {},
      // isFilter: false,
    };
  },
  mounted: function () {
    this.getFuncView();
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDate = [`${this.$moment().day(-11).format('YYYY-MM-DD')} 00:00:00`, `${this.$moment().format('YYYY-MM-DD')} 23:59:59`];
    this.reportType = 'cleanScore';
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    onExport: function (isExportLocationReport) {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.formSearch.isExportLocationReport = isExportLocationReport;
      this.formSearch.startDate = this.$momentElLocal(this.selectDate[0], 'YYYY-MM-DD');
      this.formSearch.endDate = this.$momentElLocal(this.selectDate[1], 'YYYY-MM-DD');
      this.formSearch.startDateBeforeOffSet = this.$momentElLocal(this.selectDate[0]);
      this.formSearch.endDateBeforeOffSet = this.$momentElLocal(this.selectDate[1]);
      this.exportTable('reportDailySite', this.formSearch);
    },

    // 展开项目
    // onShowDown(item) {
    //   if (typeof item.showDown === 'undefined') {
    //     this.$set(item, 'showDown', true);
    //   } else {
    //     item.showDown = !item.showDown;
    //   }
    //   if (item.showDown && !item.siteList) {
    //     this.getDownList(item);
    //   }
    // },
    // 获取项目站点
    // getDownList(item) {
    //   this.$getJSON(apis.ProralSiteList, {
    //     // locationId: item.locationId,
    //     // date: `${item.reportDate} 00:00:00`,
    //     // reportLocationId: item.reportLocationId,
    //   }).then((res) => {
    //     this.$set(item, 'siteList', res.data);
    //   });
    // },
    // 清空过滤
    onClear() {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 获取标签(项目)列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName,
          });
        }
      });
      this.tags = arr;
    },
    // 获取标签(区域)列表
    getTagsList1(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.floorId === item.floorId);
        if (!isHas && item.floorId && item.floorName) {
          arr.push({
            floorId: item.floorId,
            floorName: item.floorName,
          });
        }
      });
      this.tags1 = arr;
    },
    // 点击(项目)标签
    onItemTag(tagId) {
      if (tagId === this.tagId) {
        this.tagId = '';
      } else {
        this.tagId = tagId;
      }
    },
    // 点击(区域)标签
    onItemTag1(floorId) {
      if (floorId === this.floorId) {
        this.floorId = '';
      } else {
        this.floorId = floorId;
      }
    },
    // 过滤标签项目
    dataFilter: function (list) {
      if (!this.tagId) {
        return list;
      }
      return list.filter(t => t.tagId === this.tagId);
    },
    // 过滤标签区域
    dataFilter1: function (list) {
      if (!this.floorId) {
        return list;
      }
      return list.filter(t => t.floorId === this.floorId);
    },
    // 变更租赁方过滤
    onChangeCustomer() {
      if (!this.formSearch.orgId) {
        this.tags = [];
        this.tags1 = [];
        this.tagId = '';
        this.floorId = '';
      }
      this.reportList = [];
      this.tableList = [];
      this.totalRows = 0;
    },
    // 折线图数据
    getHisReportList() {
      if (!this.formSearch.locationId) {
        this.reportList = [];
        return;
      }
      this.formSearch.startDate = this.selectDate[0];
      this.formSearch.endDate = this.selectDate[1];
      this.formSearch.startDateBeforeOffSet = this.$momentElLocal(this.selectDate[0]);
      this.formSearch.endDateBeforeOffSet = this.$momentElLocal(this.selectDate[1]);
      this.$getJSON(apis.ProtalReportHisList, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.date = moment(item.reportDate).format('MM/DD');
          const value = item.totalUsageTime / 60;
          const digit = 2;
          item.totalUsageTime = Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit;
          item.totalCleanArea = this.$formatLenLocal(item.totalCleanArea);
          item.goalArea = this.$formatLenLocal(item.goalArea);
        });
        this.reportList = list;
      });
    },
    getChangeData() {
      this.getHisReportList();
      this.onPageChange({ page: 1 });
    },
    // 折线图分页数据
    getTableList() {
      if (!this.formSearch.locationId) {
        this.tableList = [];
        this.totalRows = 0;
        return;
      }
      // 提交需要去除这个字段 locationName
      this.$getJSON(apis.ProtalReportHisPage, Object.assign({}, this.formSearch, {
        startDate: this.$momentElLocal(this.selectDate[0], 'YYYY-MM-DD'),
        endDate: this.$momentElLocal(this.selectDate[1], 'YYYY-MM-DD'),
        locationName: '',
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' })).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.history-report-bd {
  .empty-location {
    height: 130px;
    line-height: 130px;
    background-color: #ffffff;
    color: #818181;
    font-size: 16px;
    text-align: center;
    margin: 24px 0px;
    border-radius: 16px;
  }
  .select-date {
    h1 {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: $--color-primary;
      margin-bottom: 4px;
    }
    .el-date-editor {
      transform: translateX(-8px);
    }
    input {
      font-weight: bold;
    }
    .el-range__close-icon.el-input__icon:after {
      font-family: 'icon' !important;
      content: '\E7F8';
      font-size: 22px;
      line-height: 42px;
      margin-right: 30px;
      color: $--color-warning;
    }
    .el-input__icon.el-range__icon.el-icon-date {
      color: $--color-primary;
      font-size: 18px;
      margin-top: 2px;
    }
    .el-input .el-input__inner {
      cursor: pointer;
      height: 40px;
      line-height: 41px;
      padding-left: 34px;
      font-weight: bold;
      color: $--color-text-primary;
    }
    .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
  }
  .chart-report {
    margin-top: 24px;
    padding: 24px;
    background-color: #ffffff;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02);
    border-radius: 16px;
    .el-tabs .el-tabs__item {
      font-size: 14px;
    }
    h1 {
      height: 40px;
      line-height: 40px;
      margin-bottom: 24px;
      color: #1a1a1a;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .chart-detail {
    margin-top: 24px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    padding: 24px;
    border-radius: 16px;
    &.white {
      background: #ffffff;
      border: 1px solid #ffffff;
    }
    h1 {
      height: 40px;
      line-height: 40px;
      margin-bottom: 24px;
      color: #1a1a1a;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
